/**
 * Supernova manuals API path (under axios baseURL, usually …/api).
 * Must be /v2/manuals on hosted envs where only /api/v2/* is routed; local Supernova mounts this too.
 */
export const MANUALS_API_PREFIX = '/v2/manuals';

export const MEDIA_SRC_ATTRS = [
  ['img', 'src'],
  ['source', 'src'],
  ['video', 'src'],
  ['audio', 'src'],
  ['track', 'src'],
  ['embed', 'src'],
  ['input', 'src'],
  ['video', 'poster'],
  ['audio', 'poster'],
  ['object', 'data'],
];
